import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";

const ViewFilesModal = ({
    isOpen,
    setIsOpen,
    question,
}) => {
    const [documents, setDocuments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        setIsLoading(true)
        setDocuments(question?.documents?.map((data) => {
            return {
                original_name: <div
                    className={`font-semibold highlight-text}`}
                >
                    {data?.original_name || "--"}
                </div>,
                view_file: <a
                href={data?.path}
                className="hover:text-primary text-primary underline underline-offset-4"
                target="_blank"
              >
                View File🔻
              </a>
            }
        }));
        setIsLoading(false)
    }, [question]);
    const defaultRender = (value) => (value ? value : '--');
    const columns = [
        {
            title: 'File Name',
            dataIndex: 'original_name',
            render: defaultRender,
        },
        {
            title: 'View File',
            dataIndex: 'view_file',
            render:defaultRender,
        },
    ];
    return (
        <ModalComponent
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title={"View Files"}
            width={800}
        >
            <div className="flex flex-col gap-5">
                <SkeletonTable
                    columns={columns}
                    data={documents}
                    isLoading={isLoading}
                />
            </div>
        </ModalComponent>
    );
};

export default ViewFilesModal;
